export const ru = {
    'annotation': 'Когда звонок начнется, вы будете перенаправлены на видеоконференцию, которая будет доступна в браузере. Время начала обозначено выше',
    'unavailable-title': 'Звонок недоступен',
    'unavailable-description': 'У вас нет доступа к этому звонку',
    'create-call': 'Собрать звонок',
    'today': 'Сегодня',
    'tomorrow': 'Завтра',
}
